"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../styles");

var _TimeScroll = _interopRequireDefault(require("./TimeScroll"));

var _utils = _interopRequireDefault(require("./utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Time =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Time, _PureComponent);

  function Time(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.defaultValue = _utils.default.newDate();
    _this.handleHourChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'hour');
    _this.handleMinuteChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'minute');
    _this.handleSecondChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'second');
    _this.handleAMPMChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'ampm');
    return _this;
  }

  var _proto = Time.prototype;

  _proto.getValue = function getValue() {
    return this.props.value || this.defaultValue;
  };

  _proto.handleChange = function handleChange(type, val) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        format = _this$props.format,
        min = _this$props.min,
        max = _this$props.max,
        range = _this$props.range,
        pos = _this$props.pos;
    var value = this.getValue();
    var date = new Date(value.getTime());
    var hours;

    switch (type) {
      case 'hour':
        if (format.indexOf('h') >= 0 && date.getHours() >= 12) {
          date.setHours(val + 12);
        } else {
          date.setHours(val);
        }

        break;

      case 'minute':
        date.setMinutes(val);
        break;

      case 'second':
        date.setSeconds(val);
        break;

      case 'ampm':
        hours = date.getHours();
        if (val === 1 && hours < 12) date.setHours(hours + 12);else if (val === 0 && hours >= 12) date.setHours(hours - 12);
        break;

      default:
    }

    var isDisabled;
    if (disabled) isDisabled = disabled(date);

    if (pos !== 'start') {
      if (!isDisabled && min) {
        if (_utils.default.compareAsc(date, min) < 0) return;
        if (range && _utils.default.compareAsc(date, _utils.default.addSeconds(min, range)) > 0) return;
      }

      if (!isDisabled && max) {
        if (_utils.default.compareAsc(date, max) > 0) return;
        if (range && _utils.default.compareAsc(date, _utils.default.addSeconds(max, -range)) < 0) return;
      }
    }

    if (isDisabled) return;
    this.props.onChange(date, true, false, 'time');
  };

  _proto.render = function render() {
    var format = this.props.format;
    var value = this.getValue();
    var className = (0, _styles.datepickerClass)('time-picker');
    var hours = value.getHours();

    if (format.indexOf('h') >= 0 && hours >= 12) {
      hours -= 12;
    }

    return _react.default.createElement("div", {
      className: className
    }, format.indexOf('H') >= 0 && _react.default.createElement(_TimeScroll.default, {
      value: value.getHours(),
      total: 24,
      onChange: this.handleHourChange
    }), format.indexOf('h') >= 0 && _react.default.createElement(_TimeScroll.default, {
      value: hours,
      total: 12,
      onChange: this.handleHourChange
    }), format.indexOf('m') >= 0 && _react.default.createElement(_TimeScroll.default, {
      value: value.getMinutes(),
      onChange: this.handleMinuteChange
    }), format.indexOf('s') >= 0 && _react.default.createElement(_TimeScroll.default, {
      value: value.getSeconds(),
      onChange: this.handleSecondChange
    }), /a|A/.test(format) && _react.default.createElement(_TimeScroll.default, {
      value: value.getHours() >= 12 ? 1 : 0,
      total: 2,
      ampm: true,
      onChange: this.handleAMPMChange
    }));
  };

  return Time;
}(_react.PureComponent);

Time.propTypes = {
  disabled: _propTypes.default.func,
  format: _propTypes.default.string.isRequired,
  min: _propTypes.default.object,
  max: _propTypes.default.object,
  onChange: _propTypes.default.func.isRequired,
  range: _propTypes.default.number,
  value: _propTypes.default.object,
  pos: _propTypes.default.string
};
var _default = Time;
exports.default = _default;